import { createContext } from 'react'

const directStripeContext = createContext()

export default directStripeContext
